import { render, staticRenderFns } from "./ShowCarpets.vue?vue&type=template&id=91ce535a&"
import script from "./ShowCarpets.vue?vue&type=script&lang=js&"
export * from "./ShowCarpets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports